module.exports = __webpack_public_path__ + "img/img_engineering_phone_img1.09f845ff.png";